import styled from "@emotion/styled";
import React from "react";
import DesignerIntroComponent from '../contents/designer-intro.component';
import { Container } from '../grid/grid.component';

class ProjectDesignerList extends React.Component {

  render() {
    const { designers } = this.props;
    console.log(designers);
    return (

      <Designers>
        <Container>
          {designers.map(designer => (
            <DesignerIntroComponent key={designer.id} {...designer.data} />
          ))}

        </Container>
      </Designers>

    )
  }
}

export default ProjectDesignerList


const Designers = styled.div`
  
  .designer-intro{
    margin-bottom: 200px;
  }
  .designer-intro:last-of-type{
    margin-bottom: 0;
  }
  .designer-intro:nth-of-type(even){
    > div{
      flex-direction: row-reverse;
    }
  }
`
